/**
 * react-flow `nodeTypes` registry.
 *
 * Kept in a separate file from FlowNode.tsx so Vite's Fast Refresh works —
 * react-refresh requires component-only exports from .tsx files.
 */

import { FlowNodeComponent } from "./FlowNode";

export const nodeTypes = {
  trigger: FlowNodeComponent,
  condition: FlowNodeComponent,
  switch: FlowNodeComponent,
  ab_test: FlowNodeComponent,
  schedule: FlowNodeComponent,
  checkout_page: FlowNodeComponent,
  capture_policy: FlowNodeComponent,
  delay: FlowNodeComponent,
  fraud_check: FlowNodeComponent,
};
